import { t } from "i18next"
import PropTypes from "prop-types"
import React from "react"

import Loader from "../../components/Common/Loader/loader"
import ReactTable from "../../components/Common/ReactTable"
import { useGetHistoryList } from "../../services/queries"
import { convertDateTime, formatPrice } from "../../utils/utils"

const PriceDerivationHistory = (props) => {
    const { historyObject } = props
    const { data, status } = useGetHistoryList(historyObject?.pid)
    const countryDetail = sessionStorage?.getItem("countryDetails") && JSON.parse(sessionStorage?.getItem("countryDetails"))

    const column = [
        {
            Header: t("Pricing.listPrice"),
            accessor: "price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.reimbursementPrice"),
            accessor: "reimbursement_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.orderPrice"),
            accessor: "order_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.endConsumerPrice"),
            accessor: "consumer_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.nosBasePrice"),
            accessor: "nos_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.nosOrderOriginalPrice"),
            accessor: "nos_order_price",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.nosOrderConvertedPrice"),
            accessor: "nos_order_price_converted",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.lastupdatedby"),
            accessor: "updated_by_name",
            type: "updatedBy"
        }]

    return (
        <>
            <div className="flex flex-col bg-white rounded-lg gap-1.5">
                { status === "error" && <p>{ t("common.errorFetchingData") }</p> }
                { status === "pending" && <Loader loading={ true } /> }
                { status === "success" && (
                    <>
                        <div className="color-light font-extrabold font-[800] not-italic text-sm text-[#5D6065]">
                            { 
                                <span> 
                                    { historyObject?.pricelist_name },
                                </span>
                            }                        
                            {
                                historyObject?.country ? <span> { historyObject?.country }, </span> : ""
                            } 
                            {
                                historyObject?.sales_org ? <span> { historyObject?.sales_org }, </span> : ""
                            }
                            {
                                historyObject?.article_name ? <span> { historyObject?.article_name } </span> : ""
                            }
                        </div>
                        <ReactTable
                            columns={ column }
                            data={ data?.data }
                            disableSearch={ true }
                            status = { status }
                        />
                    </>
                ) }

            </div>
        </>
    )

}
PriceDerivationHistory.propTypes = {
    historyObject: PropTypes.shape({
        article_name: PropTypes.string,
        country: PropTypes.string,
        pid: PropTypes.string,
        pricelist_name: PropTypes.string,
        sales_org: PropTypes.string
    })
}

export default PriceDerivationHistory
